/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".user_staff[_ngcontent-%COMP%]{margin:10px 0 30px}.user_staff[_ngcontent-%COMP%]   mat-card-content[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between}[_nghost-%COMP%]   button.mat-accent[_ngcontent-%COMP%], [_nghost-%COMP%]   button.mat-primary[_ngcontent-%COMP%]{padding:8px 24px;border-radius:8px;box-shadow:0 2px 4px 0 rgba(0,0,0,.08);background-color:#182365;line-height:unset!important}"];
export { styles as styles };
